import context from "express-http-context";

function getSessionFromContext () {
  const session = context.get("session") ?? "";

  return session;
}

export default getSessionFromContext;
